export const CLOUD_STOAGE = {
    ACCOUNT_MASTER: "/AccountMasterCompanyLogo",
    EVIDENCE_MASTER: "/EvidenceForNCPointsOfAudits",
    THIRD_PARTY_AUDIT_ATTACHMENTS: "/ThirdPartyAuditAttachments",
    THIRD_PARTY_AUDIT_REPORT_URL: "/ThirdPartyAuditReportURL",
}